import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { MedicalAppointment } from '../../../model/medical-appointment';
import { MatDialog } from '@angular/material';
import { MedicalAppointmentReappointmentDialogComponent } from '../../dialogs/medical-appointment-reappointment/medical-appointment-reappointment-dialog.component';
import { ConfirmDialogService } from '../../../services/confirm-dialog.service';
import { MedicalServiceService } from '../../../services/medical-service.service';
import { NotificationToastService } from '../../../services/notification-toast.service';

@Component({
    selector: 'app-medical-appointment-reappointment-control',
    templateUrl: './medical-appointment-reappointment-control.component.html',
    styleUrls: ['./medical-appointment-reappointment-control.component.css']
  })
export class MedicalAppointmentReappointmentControlComponent implements OnInit {
    actionVisible = true;
    isReAppointment = false;
    @Input() medicalAppointmentId: number;
    // tslint:disable-next-line:no-output-on-prefix
    @Output() onReAppointmentChange = new EventEmitter();

    constructor(private dialog: MatDialog
        , private notificationToastService: NotificationToastService
        , private medicalServiceService: MedicalServiceService
        , private confirmDialogService: ConfirmDialogService) {
    }

    get actionText() { return this.isReAppointment ? 'No recitar' : 'Recitar'; }

    async doAction() {
        if (!this.isReAppointment) {
            const dialogRef = this.dialog.open(MedicalAppointmentReappointmentDialogComponent, {
                width: '50%',
                data:  this.medicalAppointmentId
            });
            dialogRef.afterClosed().subscribe((value) => {
                if (value) {
                 this.onReAppointmentChange.emit();
                }
            });
        } else {
            this.confirmDialogService.confirm('Recitación de turno'
            , '¿Está seguro de revertir la marca de recitación?'
            , 'Aceptar', 'Cancelar').subscribe(async (value) => {
                if (value) {
                    await this.medicalServiceService.medicalAppointmentUnCheckReappointment(this.medicalAppointmentId);
                    this.onReAppointmentChange.emit();
                }
            });
        }
    }

    async ngOnInit()  {
        try {
          if (this.medicalAppointmentId) {
            this.isReAppointment =  await this.medicalServiceService.isReAppointmentCheck(this.medicalAppointmentId);
          } else {
            this.actionVisible = false;
          }
        } catch (err) {
            this.notificationToastService.error(JSON.stringify(err.error), 'Recitación');
        }
    }

}
